module.exports = __webpack_public_path__ + "static/media/engage-sprint2.0d45280e.jpg";